
import { defineComponent } from 'vue'
import { salesClosed, registrationClosed } from '@/utils/ServiceAvailability'
export default defineComponent({ data: () => ({ salesClosed, registrationClosed }) })
